import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';
import { baseUrl } from '@/src/assets/utils/baseUrl';
import { getImageUrl } from '@/src/assets/utils/getImageUrl';

import { BlogPostContent } from '../../blog/blogPostContent/BlogPostContent';
import { BlogPostFoot } from '../../blog/blogPostFoot/BlogPostFoot';
import { BlogPostHead } from '../../blog/blogPostHead/BlogPostHead';
import { BlogReadNext } from '../../blog/blogReadNext/BlogReadNext';
import Layout from '../../layout/Layout';

import styles from './Post.module.scss';

interface PostProps {
    post: BlogPostInterface;
}
const Post: FC<PostProps> = ({ post }) => {
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: post.title,
        url: baseUrl(`/blog/${post.slug}`),
        description: post.metaDescription,
        dateCreated: post.dateOfCreation,
        datePublished: post.dateOfCreation,
        dateModified: post._updatedAt,
        image: getImageUrl(post.image),
        author: {
            '@type': 'Organization',
            name: 'High Five Themes',
        },
        publisher: {
            '@type': 'Organization',
            name: 'High Five Themes',
            url: baseUrl(),
        },
    };

    return (
        <>
            <Layout
                jsonLD={jsonLd}
                meta={{
                    metaTitle: post.metaTitle,
                    metaDescription: post.metaDescription,
                    metaImageUrl: !!post.ogImage && getImageUrl(post.ogImage),
                    ogTitle: post.metaTitle,
                    ogDescription: post.metaDescription,
                    ogType: 'article',
                }}>
                <article className={styles.blogPost}>
                    <BlogPostHead
                        title={post.title}
                        excerpt={post.excerpt}
                        updateDate={post._updatedAt}
                        tags={post.tags}
                        slug={post.slug}
                        estimatedReadingTime={post.estimatedReadingTime}
                        featureImage={post.image}
                    />
                    <BlogPostContent content={post.content} />
                    <BlogPostFoot
                        postSlug={post.slug}
                        postUpdateDate={post._updatedAt}
                        postTags={post.tags}
                    />
                    {post.readNextPosts && post.readNextPosts.length && (
                        <BlogReadNext posts={post.readNextPosts} />
                    )}
                </article>
            </Layout>
        </>
    );
};

export { Post };
